export default {
  common: {
    errors: {
      title: "Error",
      warning: "Attention",
      note: "Note",
      searchSubscribers: "Search for subscribers",
      pointAlreadyExists:
        "A reading with the same metering point number already exists",
      payDateDiff: "The payment date is much later than the pay period",
      readingNotBeCalc:
        "The reading entered for a non-existent accounting point will not be taken into account in the calculations",
      conditionNotSet: "Condition not set",
      usernameNotFoundInDatabase: "Username is not found in the base",
      usernameOrPasswordNotFound: "Username or password is not found",
      accessDenied: "Access denied",
      invalidUsernameOrPassword: "Invalid username or password",
      accountExpired: "Account expired",
      sessionExpired: "Session expired",
      networkError: "Error connecting to server"
    },
    menu: {
      massinput: {
        name: "Mass input",
        enteringPayments: {
          name: "Payments",
          desc:
            "Input of utility payments of subscribers received from receiving organizations"
        },
        enteringSubsidies: {
          name: "Subsidies",
          desc:
            "Introduction of subsidies, compensation for the visually impaired, etc., received from the department of subsidies"
        }
      },
      subscribers: {
        name: "Subscribers",
        desc: "Searching and viewing information about subscribers"
      },
      searchchange: {
        name: "Search and change",
        errorpayments: {
          name: "Erroneous payments",
          desc: "View and correct erroneous payments"
        }
      },
      paymentdocuments: {
        name: "Payment documents",
        bankPay: {
          name: "Bank payments",
          desc: "Bank payments handling"
        },
        packsReceipts: {
          name: "Packs of payments/subsidy",
          desc: "Working with packs headers of payments/subsidy"
        },
        relationship: {
          name: "Payments and packs relations",
          desc: "Establishing relations between received payments and packs"
        },
        assignOperators: {
          name: "Assignment of operators",
          desc: "Assignment of operators for working with packs"
        },
        controlPacks: {
          name: "Control over packs delivery",
          desc: "Control over correctness of packs delivery"
        },
        controlInetPays: {
          name: "Control over internet payments",
          desc: "Control over internet payments admission"
        }
      },
      reports: {
        name: "Reports",
        desc: "Formation of reporting forms"
      },
      acceptedshipment: {
        name: "Accepted Shipment Report",
        desc:
          "Report for comparing accepted shipments from the “Supplier” and the “Network Company”"
      },
      settings: {
        name: "Settings",
        desc: "User settings"
      },
      user: {
        currentUser: "User",
        currentConnection: "Connection",
        about: "About",
        settings: "Settings",
        signOut: "Sign out"
      }
    },
    about: {
      modal: {
        title: "About",
        descritpionAbon: "Charging subscription fees",
        descritpionComm: "for utilities",
        clientVersion: "Client version: {version}",
        serverVersion: "Server version: {version}",
        apiVersion: "App server version: {version}"
      }
    },
    filter: {
      info: {
        periodWith: "Period from",
        periodTo: "to",
        sumMin: "Min amount",
        sumMax: "Max amount",
        statementSpaced: "Delivered statements",
        statementSet: "Composing statements",
        organization: "Organization",
        payment: "Payment method",
        showSpaced: "Delivered packs",
        statusPack: "Pack status",
        operator: "Operator"
      },
      modal: {
        title: "Filter for data display"
      },
      form: {
        dateRange: {
          title: "Period",
          from: "from",
          start: "Start date",
          end: "End date",
          separator: "to"
        },
        sumRange: {
          title: "Total",
          from: "from",
          to: "to"
        },
        statementStatus: {
          title: "Statement status",
          exploded: "Delivered",
          unexploded: "Not delivered"
        },
        organization: {
          title: "Organization"
        },
        payment: {
          title: "Payment method"
        },
        showSpaced: {
          title: "Show delivered"
        },
        statusPack: {
          title: "Pack status"
        },
        operator: {
          title: "Operator"
        }
      }
    },
    compliance: {
      info: {
        datesDifference: "Dates difference (in days)",
        organizationsMatch: "Organizations match",
        paymentMethodsMatch: "Payment methods match",
        amountDifference: "Amount difference"
      },
      modal: {
        title: "Parameters of accordance between payments and packs"
      },
      form: {
        datesDifference: {
          title: "Bans date",
          days: "days"
        },
        organizationsMatch: {
          title: "Organizations match"
        },
        paymentMethodsMatch: {
          title: "Payment methods match"
        },
        amountDifference: {
          title: "Amount difference"
        }
      }
    },
    validations: {
      dateRange: {
        message: "You must select a date"
      },
      sumRange: {
        message: "Amount cannot be greater than the previous amount"
      },
      statementStatus: {
        message: "You must select statement type"
      },
      datebank: {
        message: "You must select a date",
        dateNow: "Bank date cannot be greater than the current date",
        dateClose: "Bank date cannot fall within a closed month"
      },
      datepay: {
        message: "You must select a date",
        dateNow: "Payment date cannot be greater than the current date",
        dateCompare:
          "Payment date cannot be less than the date of subscriber creation"
      },
      quantity: {
        message: "Specify the quantity of payments",
        required: "Field cannot be empty",
        status:
          "Quantity of payments in statement and quantity of inserted payments do not match"
      },
      countband: {
        required: "Field cannot be empty"
      },
      summa: {
        message: "Select amount",
        required: "Amount field cannot be empty",
        status:
          "The amount of payments and the amount of selected payments do not match"
      },
      beneficiaryAccount: {
        message: "You must select recipient account"
      },
      paymentStatus: {
        message: "You must select payment type"
      },
      codefirme: {
        message: "You must select sender"
      },
      payment: {
        message: "You must select payment method"
      },
      encoding: {
        message: "You must select an encoding"
      },
      uploadFile: {
        message: "You must select at least one file",
        onlyOne: "Only one file can be downloaded"
      },
      confirmeCodefirme: {
        message: "You must select organization"
      },
      paynumber: {
        required: "Field № of document cannot be empty"
      },
      rcount: {
        message: "You must select sender account"
      },
      summaPack: {
        aboveZero: "Must be above zero",
        notEqualZero: "Cannot be equal to zero"
      },
      userPayment: {
        message: "You must assign operator"
      },
      codeImport: {
        message: "You must choose input data type"
      },
      files: {
        message: "You must add import file"
      },
      reasonStorn: {
        message: "You must select a reason"
      },
      statusCode: {
        message: "You must select pack status"
      },
      confirmDateBank: {
        message: "You must select a date"
      },
      codepay: {
        message: "You must select the purpose of the payment"
      },
      sumPay: {
        message: "Amount cannot be empty",
        sumGrtZero: "Payment amount must be greater than zero"
      },
      datePayPeriod: {
        message: "You must specify the start date of the period",
        datePayEnd: "You must specify the end date of the period",
        datePayCompare: "Start date must be less than end date"
      },
      reasonReturnPack: {
        message: "You must select a reason for returning the pack"
      },
      massInputQuantity: {
        message: "This field cannot be empty",
        quantityGrtZero: "Number of receipts must be greater than zero",
        subscribersGrtZero: "Number of subscribers must be greater than zero"
      },
      massInputTotalSum: {
        message: "This field cannot be empty",
        sumGrtZero: "Total amount must be greater than zero"
      },
      sumBegin: {
        beginGtEnd: "The initial amount cannot be greater than the final one",
        endSumEmpty: "You must select the final amount"
      },
      sumEnd: {
        endLtBegin: "The final sum cannot be less than the initial one",
        beginSumEmpty: "You must select a starting amount."
      },
      dateBegin: {
        beginIsAfterEnd: "Start date cannot be greater than end date",
        endDateEmpty: "You must select an end date"
      },
      dateEnd: {
        endIsBeforeBegin: "The end date cannot be less than the start date",
        beginDateEmpty: "You must select a start date"
      }
    },
    gridColumns: {
      nameaccount: "Account",
      datebank: "Bank date",
      datebankPay: "Date of transfer",
      quantityPay: "Quantity of payments",
      totalSumma: "Total amount",
      summa: "Amount",
      sumwithoutprof: "Amount without services",
      summtrans: "Amount of transfer",
      summpay: "Amount of payments",
      status: "Status",
      astatus: "Com. fee",
      datebeginfact: "Date",
      dateDelete: "Deletion date",
      username: "Operator",
      namefirme: "Payer",
      namefirmeSender: "Sender",
      namefirmeSenderPay: "Sender of payment",
      okpo: "OKPO",
      okpoPay: "Sender OKPO",
      datepay: "Date of payment",
      paynumber: "Number of payment",
      mess: "Note",
      npack: "Connected to pack",
      npackStatus: "Payment status",
      npackSystem: "System number of the pack",
      kindname: "Payment method",
      countband: "Quantity of parcels",
      countbands: "Parcles",
      quantity: "Quantity of receipts",
      quantitys: "Receipts",
      sumprof: "For services",
      isimport: "Import",
      packnumber: "Pack number",
      abcode: "P.account",
      abcodeLong: "Personal account",
      fio: "Full name",
      payname: "Purpose of payment",
      dateval: "Date of taking readings",
      counter: "Reading",
      impFile: "File",
      processed: "Processed",
      transferid: "Registry code",
      statusname: "Status",
      nband: "№",
      countpay: "Quantity",
      countpays: "Quantity of payments",
      abcodeNumber: "Subscriber No.",
      nameplat: "Service",
      adress: "Adress",
      intkey: "Payment code",
      reasonname: "Reason for return",
      clientId: "ID",
      regionName: "District",
      streetName: "Street",
      nHouse: "House No.",
      charHouse: "Letter",
      nFlat: "Apartment",
      charFlat: "Apartment letter",
      phone: "Phone",
      dateCreate: "Opened",
      dateClose: "Closed",
      arch: "Archive",
      postIndex: "Postcode",
      countRoom: "Lot number",
      partyHouse: "Entrance",
      floor: "Floor",
      topIndex: "No. metering point",
      service: "Service",
      zone: "Zone",
      reading: "Reading",
      status: "Considered",
      payment: "Payment",
      error: "Error",
      npack: "Pack",
      sumorig: "Amount in payment currency",
      currencyname: "Payment currency",
      bank: "Bank",
      validity: "Validity period",
      datebegin: "Start date",
      dateend: "End date",
      makingEntry: "Making an entry",
      house: "House",
      charHouseLong: "House letter",
      charFlatLong: "Apartment letter",
      closeReasonName: "Reason for closing a p/account",
      habitName: "Build Type",
      propertyName: "Property type",
      npack: "Bundle no.",
      lists: "Sheets",
      subsidiesSocBenefits: "Subsidies/soc.benefits",
      appointmentDate: "Appointment date",
      dateBeginAction: "Start of action",
      dateEndAction: "End of action",
      dateReading: "Date of reading",
      organization: "Organization"
    },
    types: {
      status: {
        posting: "delivered",
        inSet: "composing"
      },
      astatus: {
        yes: "has",
        no: "does not have"
      },
      npackStatus: {
        alien: "alien",
        associatedPack: "related to pack",
        expectedPack: "pack expected"
      },
      processed: {
        yes: "yes",
        no: "no"
      }
    },
    options: {
      payment: {
        zero: "must be connected to specific pack",
        one: "alien"
      },
      searchTypes: {
        matches: "= matches",
        contains: "* contains",
        startsOn: "> starts with",
        endsOn: "< ends with"
      },
      searchDateTypes: {
        equal: "equal",
        between: "between"
      }
    },
    buttons: {
      filter: "Filter",
      compliance: "Accordance",
      add: "Add",
      edit: "Edit",
      delete: "Storno",
      deletePacks: "Deleted packs",
      remove: "Delete",
      removeAll: "Delete all",
      fix: "Fix",
      distribute: "Distribute",
      import: "Import",
      imports: "Import",
      report: "Report",
      importDots: {
        import: "Import...",
        payments: "payments",
        subsidies: "subsidies",
        dbfFile: "DBF-file",
        csvFile: "CSV-file"
      },
      extraDots: {
        extra: "Extra...",
        indefinite: "show receipts with undefined readings"
      },
      viewDots: {
        view: "View",
        optimal: "Optimal",
        full: "Full"
      },
      alien: "Alien",
      posting: "Deliver",
      submit: "Submit",
      cancel: "Cancel",
      refund: "Refund",
      selectFile: "Select file",
      addFile: "Add file",
      deleteFile: "Delete file",
      upload: "Upload",
      close: "Close",
      link: "Link",
      linkAndPosting: "Link and Posting",
      packForPayment: "Create bundle for payment",
      assign: "Assign",
      unassign: "Unassign",
      receipts: "Receipts",
      moveToNextMonth: "Move to mext month",
      cancelReceivedRegistry: "Cancel received result",
      cancelSubscriberPayment: "Cancel subscriber payment",
      confirmYes: "Yes",
      confirmNo: "No",
      confirmOk: "OK",
      infoPay: "Payment information",
      errorPayments: "Erroneous payments", // delete this ?
      searchSubscribers: "Search subscribers",
      searchPayments: "Search payments",
      subscriberCard: "Subscriber card",
      search: "Search",
      clear: "Clear",
      aboutClient: "About the client",
      return: "Return",
      postpone: "Postpone",
      distributeAll: "Distribute all",
      refreshList: "Refresh list",
      check: "Check",
      save: "Save"
    },
    components: {
      select: {
        placeholder: "Select"
      },
      datePicker: {
        placeholder: "Date",
        today: "Today",
        yesterday: "Yesterday"
      }
    },
    reference: {
      statusName: {
        inSet: "composing",
        inPosting: "delivering",
        spaced: "delivered",
        notConnected: "not related",
        erroneous: "wrong",
        canceled: "stornoed"
      },
      paymentName: {
        preparationPayment: "preparation for payment",
        paymentMade: "payment made",
        paymentNotMade: "payment not made",
        undefined: "undefined"
      },
      deliveryName: {
        moneySent: "money sent",
        paymentNotDeterm: "payment not determined",
        mismatchAmounts: "mismatch of ammounts",
        undefined: "undefined"
      }
    },
    checkVersion: {
      api: "API version must be",
      server: "Server version must be",
      callTo: "or higher, contact your administrator to update the server",
      serverError: "Server connection error:",
      dataBase: "Database version",
      appServer: "does not match the version of the application server"
    },
    address: {
      street: "st. ",
      house: "",
      flat: "-",
      address: "address:",
      abcode: "p/a"
    },
    route: {
      leave:
        "There are still unopened packs left. Would you like to leave them unsplit?"
    }
  }
};
